import { observer } from 'mobx-react-lite'
import { IconButton, Typography } from 'shared/ui'
import { PageNumberInfo } from 'shared/ui/PageNumberInfo/PageNumberInfo'
import { UpgradeSecondLeftContent } from 'pages/settings/pages/billing/pages/upgrade/ui/SecondLeftContent/UpgradeSecondLeftContent'
import { UpgradeSecondRightContent } from 'pages/settings/pages/billing/pages/upgrade/ui/SecondRightContent/UpgradeSecondRightContent'
import { useBillingUpgradePageContext } from 'pages/settings/pages/billing/pages/upgrade/context/upgradeContext'
import styles from './styles.module.scss'

export const UpgradeSecondPage = observer(() => {
  const store = useBillingUpgradePageContext()
  const { previousStep, currentStep, totalSteps, isDowngrade } = store

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerNav}>
          <IconButton
            icon='arrowLeft'
            ariaLabel='previous-step'
            size='medium'
            variant='icon'
            color='tertiary'
            className={styles.previousStepButton}
            onClick={previousStep}
          />
          <PageNumberInfo
            currentStep={currentStep}
            totalSteps={totalSteps}
            title={isDowngrade ? 'Downgrade' : 'Upgrade'}
          />
        </div>
        <Typography
          ariaLabel='billing_upgrade_second_page_title'
          className={styles.title}
          variant='body-xl-medium'
          tag='div'
          marginTop={34}
        >
          Checkout
        </Typography>
      </div>

      <div className={styles.checkoutContainer}>
        <UpgradeSecondLeftContent />

        <UpgradeSecondRightContent />
      </div>
    </div>
  )
})
